<script lang="ts">
	import culture from "../assets/aboutUs/culture.png?webp&h=466&imagetools";
	import socialField from "../assets/aboutUs/social-field.png?webp&h=466&imagetools";
	import sport from "../assets/aboutUs/sport.png?webp&h=466&imagetools";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./WeSupport.translations.json" with { type: "json" };
	import Formatted from "./common/Formatted.svelte";
	import Media from "./common/Media.svelte";

	const translate = getTranslate(translations);
	const imageHeight = 466;
</script>

<section>
	<div class="flex flex-col gap-4 md:gap-10 md:mb-24 mb-8">
		<h2 class="text-center"><Formatted text={translate("heading")} /></h2>
		<p class="text-center text-zms-optical-black md:text-[1.5rem]/[1.4]">
			<Formatted text={translate("subheading")} />
		</p>
	</div>

	<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
		<!-- Sociální oblast -->
		<div class="flex flex-col">
			<div class="relative rounded-2xl overflow-hidden h-[15rem] md:h-[29.125rem]">
				<Media
					class="object-cover w-full h-full"
					source={{ src: socialField, type: "image/webp" }}
					width={0}
					height={imageHeight}
					alt={translate("socialTitle")}
				/>
				<div class="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
				<div
					class="absolute inset-0 backdrop-blur-xl [mask:linear-gradient(transparent,transparent,black,black)]"
				></div>
				<div class="absolute inset-0 flex items-end p-6">
					<h3 class="text-white text-2lg font-medium"><Formatted text={translate("socialTitle")} /></h3>
				</div>
			</div>
			<p class="p-6 text-zms-optical-black">
				<Formatted text={translate("socialDescription")} />
			</p>
		</div>

		<!-- Sport -->
		<div class="flex flex-col">
			<div class="relative rounded-2xl overflow-hidden h-[15rem] md:h-[29.125rem]">
				<Media
					class="object-cover w-full h-full"
					source={{ src: sport, type: "image/webp" }}
					width={0}
					height={imageHeight}
					alt={translate("sportTitle")}
				/>
				<div class="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
				<div
					class="absolute inset-0 backdrop-blur-xl [mask:linear-gradient(transparent,transparent,black,black)]"
				></div>
				<div class="absolute inset-0 flex items-end p-6">
					<h3 class="text-white text-2lg font-medium"><Formatted text={translate("sportTitle")} /></h3>
				</div>
			</div>
			<p class="p-6 text-zms-optical-black">
				<Formatted text={translate("sportDescription")} />
			</p>
		</div>

		<!-- Kultura -->
		<div class="flex flex-col">
			<div class="relative rounded-2xl overflow-hidden h-[15rem] md:h-[29.125rem]">
				<Media
					class="object-cover w-full h-full"
					source={{ src: culture, type: "image/webp" }}
					width={0}
					height={imageHeight}
					alt={translate("cultureTitle")}
				/>
				<div class="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
				<div
					class="absolute inset-0 backdrop-blur-xl [mask:linear-gradient(transparent,transparent,black,black)]"
				></div>
				<div class="absolute inset-0 flex items-end p-6">
					<h3 class="text-white text-2lg font-medium"><Formatted text={translate("cultureTitle")} /></h3>
				</div>
			</div>
			<p class="p-6 text-zms-optical-black">
				<Formatted text={translate("cultureDescription")} />
			</p>
		</div>
	</div>
</section>
